import { IVehicleSearch } from "../../interfaces/VehicleSearch";

/* checks if the sum is free
/* for reservation
/* used to allow free of charge
/* @param: vehicle
*/

export const determineFree = function (vehicle: IVehicleSearch | undefined, services: any, reservationLength?: number) {
  if(!vehicle || !reservationLength) {
    return false;
  }
  
  if (vehicle.onsale || vehicle.privateData?.vip) {
    return false;
  }

  if (vehicle.pricingData.withCoupon === null) {
    return false;
  } else {
    let kmPricewithCoupon;
    if (services.kmRange === 0) {
      kmPricewithCoupon = vehicle.pricingData.withCoupon!.unlimitedKilometers / 100;
    } else {
      if (services.kmRange > 100) {
        // additional km over 100 are not part of the discount, so we will use base price
        kmPricewithCoupon = vehicle.pricingData.base.pricePerKilometer / 100 * (services.kmRange - 100);
      } else {
        kmPricewithCoupon = 0;
      }
    }

    let priceAfterDiscount = vehicle.pricingData.withCoupon!.totalPrice / 100 +
      ((services.insurance?.includes('1030') ? vehicle.pricingData.withCoupon!.highDeductible / 100 : 0) +
          (services.insurance?.includes('1028') ? vehicle.pricingData.withCoupon!.lowDeductible / 100 : 0) +
          (services.insurance?.includes('1053') ? vehicle.pricingData.withCoupon!.midDeductible / 100 : 0) +
          (services.windshield ? vehicle.pricingData.withCoupon!.windshieldInsurance / 100 : 0) +
          (services.tireInsurance ? vehicle.pricingData.withCoupon!.tireInsurance / 100 : 0) +
          (services.cancellationInsurance ? vehicle.pricingData.withCoupon?.cancellationInsurance / 100 : 0) +
          (services.additionalDriver ? vehicle.pricingData.withCoupon?.additionalDriver / 100 : 0) +
          (services.export ? vehicle.pricingData.withCoupon?.export / 100 : 0) +
          (services.hook ? vehicle.pricingData.withCoupon?.towHitch / 100 : 0) +
          (services.co2compensation === '1047' ? vehicle.pricingData.base.hundredTwentyFiveGramsCOTwo! / 100 : 0) +
          (services.co2compensation === '1048' ? vehicle.pricingData.base.fiveHundredGramsCOTwo / 100 : 0) +
          (services.co2compensation === '1049' ? vehicle.pricingData.base.sevenHundredGramsCOTwo / 100 : 0) + kmPricewithCoupon) *
        reservationLength;

    return priceAfterDiscount<=0;
  } 
};

/* calculate base services together
/* km price in case of other than standard 100km/d case
/* insurances
/* export
/* hook
/* value is not multiplied by the length of the reservation
*/

export const servicesPriceBase = function (vehicle: IVehicleSearch, services: any, reservationLength?: number ) {
  let kmPrice;

  if (services === undefined) return 0;

  if (!reservationLength) return 0;
  
  if (services.kmRange === 0) {
    kmPrice = vehicle.pricingData.base.unlimitedKilometers / 100;
  } else {
    if (services.kmRange > 100) {
      kmPrice = vehicle.pricingData.base.pricePerKilometer / 100 * (services.kmRange - 100);
    } else {
      kmPrice = 0; // this accounts for one-way service (kmRange = 100)
    }
  }
  let price = kmPrice*reservationLength;
  if (services.insurance.includes('1030')) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1030']) {
      price += vehicle.pricingData.base.highDeductible / 100 * vehicle.servicesMaxChargeableDays['1030'];
      services.insuranceReservationLength = vehicle.servicesMaxChargeableDays['1030'];
    } else {
      price += vehicle.pricingData.base.highDeductible / 100 * reservationLength;
      services.insuranceReservationLength = reservationLength;
    }
  } 
  
  if (services.insurance.includes('1028'))  {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1028']) {
      price += vehicle.pricingData.base.lowDeductible / 100 * vehicle.servicesMaxChargeableDays['1028'];
      services.insuranceReservationLength = vehicle.servicesMaxChargeableDays['1028'];
    } else {
      price += vehicle.pricingData.base.lowDeductible / 100 * reservationLength;
      services.insuranceReservationLength = reservationLength;
    }
  }

  if (services.insurance.includes('1053'))  {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1053']) {
      price += vehicle.pricingData.base.midDeductible / 100 * vehicle.servicesMaxChargeableDays['1053'];
      services.insuranceReservationLength = vehicle.servicesMaxChargeableDays['1053'];
    } else {
      price += vehicle.pricingData.base.midDeductible / 100 * reservationLength;
      services.insuranceReservationLength = reservationLength;
    }
  }

  if (services.windshield === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1026']) {
      price += vehicle.pricingData.base.windshieldInsurance / 100 * vehicle.servicesMaxChargeableDays['1026'];
      services.windshieldReservationLength = vehicle.servicesMaxChargeableDays['1026'];
    } else {
      price += vehicle.pricingData.base.windshieldInsurance / 100 * reservationLength;
      services.windshieldReservationLength = reservationLength;
    }
  }
  if (services.tireInsurance === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1038']) {
      price += vehicle.pricingData.base.tireInsurance / 100 * vehicle.servicesMaxChargeableDays['1038'];
      services.tireInsuranceReservationLength = vehicle.servicesMaxChargeableDays['1038'];
    } else {
      price += vehicle.pricingData.base.tireInsurance / 100 * reservationLength;
      services.tireInsuranceReservationLength = reservationLength;
    }
  }
  if (services.cancellationInsurance === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1040']) {
      price += vehicle.pricingData.base.cancellationInsurance / 100 * vehicle.servicesMaxChargeableDays['1040'];
      services.cancellationInsuranceReservationLength = vehicle.servicesMaxChargeableDays['1040'];
    } else {
      price += vehicle.pricingData.base.cancellationInsurance / 100 * reservationLength;
      services.cancellationInsuranceReservationLength = reservationLength;
    }
  }
  if (services.additionalDriver === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1041']) {
      price += vehicle.pricingData.base.additionalDriver / 100 * vehicle.servicesMaxChargeableDays['1041'];
      services.additionalDriverReservationLength = vehicle.servicesMaxChargeableDays['1041'];
    } else {
      price += vehicle.pricingData.base.additionalDriver / 100 * reservationLength;
      services.additionalDriverReservationLength = reservationLength;
    }
  }
  if (services.export === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1023']) {
      price += vehicle.pricingData.base.export / 100 * vehicle.servicesMaxChargeableDays['1023'];
      services.exportReservationLegth = vehicle.servicesMaxChargeableDays['1023'];
    } else {
      price += vehicle.pricingData.base.export / 100 * reservationLength;
      services.exportReservationLegth = reservationLength;
    }
  }
  if (services.hook === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1027']) {
      price += vehicle.pricingData.base.towHitch / 100 * vehicle.servicesMaxChargeableDays['1027'];
      services.hookReservationLength = vehicle.servicesMaxChargeableDays['1027'];
    } else {
      price += vehicle.pricingData.base.towHitch / 100 * reservationLength;
      services.hookReservationLength = reservationLength;
    }
  }
  if (services.co2compensation === '1047') {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1047']) {
      price += vehicle.pricingData.base.hundredTwentyFiveGramsCOTwo! / 100 * vehicle.servicesMaxChargeableDays['1047'];
      services.co2CompensationReservationLength = vehicle.servicesMaxChargeableDays['1047'];
    } else {
      price += vehicle.pricingData.base.hundredTwentyFiveGramsCOTwo! / 100 * reservationLength;
      services.co2CompensationReservationLength = reservationLength;
    }
  }
  if (services.co2compensation === '1048') {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1048']) {
      price += vehicle.pricingData.base.fiveHundredGramsCOTwo  / 100 * vehicle.servicesMaxChargeableDays['1048'];
      services.co2CompensationReservationLength = vehicle.servicesMaxChargeableDays['1048'];
    } else {
      price += vehicle.pricingData.base.fiveHundredGramsCOTwo  / 100 * reservationLength;
      services.co2CompensationReservationLength = reservationLength;
    }
  }
  if (services.co2compensation === '1049') {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1049']) {
      price += vehicle.pricingData.base.sevenHundredGramsCOTwo  / 100 * vehicle.servicesMaxChargeableDays['1049'];
      services.co2CompensationReservationLength = vehicle.servicesMaxChargeableDays['1049'];
    } else {
      price += vehicle.pricingData.base.sevenHundredGramsCOTwo  / 100 * reservationLength;
      services.co2CompensationReservationLength = reservationLength;
    }
  }
  return price;
};

/* calculate nonmember base services together
/* km price in case of other than standard 100km/d case
/* insurances
/* export
/* hook
/* value is not multiplied by the length of the reservation
*/

export const nonMemberServicesPriceBase = function (vehicle: IVehicleSearch) {
  return 0;
  /* if (services.kmRange === 0) {
    kmPrice = vehicle.pricingData.nonMember.unlimitedKilometers / 100;
  } else {
    if (services.kmRange > 100) {
      kmPrice = vehicle.pricingData.nonMember.pricePerKilometer / 100 * (services.kmRange - 100);
    } else {
      kmPrice = 0;
    }
  }
  var price = kmPrice*reservationLength;
  if (services.insurance.includes('1030')) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1030']) {
      price += vehicle.pricingData.nonMember.highDeductible / 100 * vehicle.servicesMaxChargeableDays['1030'];
    } else {
      price += vehicle.pricingData.nonMember.highDeductible / 100 * reservationLength;
    }
  }

  if (services.insurance.includes('1028'))  {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1028']) {
      price += vehicle.pricingData.nonMember.lowDeductible / 100 * vehicle.servicesMaxChargeableDays['1028'];
    } else {
      price += vehicle.pricingData.nonMember.lowDeductible / 100 * reservationLength;
    }
  }

  if (services.windshield === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1026']) {
      price += vehicle.pricingData.nonMember.windshieldInsurance / 100 * vehicle.servicesMaxChargeableDays['1026'];
    } else {
      price += vehicle.pricingData.nonMember.windshieldInsurance / 100 * reservationLength;
    }
  }
  if (services.tireInsurance === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1038']) {
      price += vehicle.pricingData.nonMember.tireInsurance / 100 * vehicle.servicesMaxChargeableDays['1038'];
    } else {
      price += vehicle.pricingData.nonMember.tireInsurance / 100 * reservationLength;
    }
  }
  if (services.cancellationInsurance === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1040']) {
      price += vehicle.pricingData.nonMember.cancellationInsurance / 100 * vehicle.servicesMaxChargeableDays['1040'];
    } else {
      price += vehicle.pricingData.nonMember.cancellationInsurance / 100 * reservationLength;
    }
  }
  if (services.additionalDriver === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1041']) {
      price += vehicle.pricingData.nonMember.additionalDriver / 100 * vehicle.servicesMaxChargeableDays['1041'];
    } else {
      price += vehicle.pricingData.nonMember.additionalDriver / 100 * reservationLength;
    }
  }
  if (services.export === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1023']) {
      price += vehicle.pricingData.nonMember.export / 100 * vehicle.servicesMaxChargeableDays['1023'];
    } else {
      price += vehicle.pricingData.nonMember.export / 100 * reservationLength;
    }
  }
  if (services.hook === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1027']) {
      price += vehicle.pricingData.nonMember.towHitch / 100 * vehicle.servicesMaxChargeableDays['1027'];
    } else {
      price += vehicle.pricingData.nonMember.towHitch / 100 * reservationLength;
    }
  }
  if (services.co2compensation == '1047') {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1047']) {
      price += vehicle.pricingData.nonMember.hundredTwentyFiveGramsCOTwo / 100 * vehicle.servicesMaxChargeableDays['1047'];
      co2CompensationReservationLength = vehicle.servicesMaxChargeableDays['1047'];
    } else {
      price += vehicle.pricingData.nonMember.hundredTwentyFiveGramsCOTwo / 100 * reservationLength;
      co2CompensationReservationLength = reservationLength;
    }
  }
  if (services.co2compensation == '1048') {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1048']) {
      price += vehicle.pricingData.nonMember.fiveHundredGramsCOTwo  / 100 * vehicle.servicesMaxChargeableDays['1048'];
      co2CompensationReservationLength = vehicle.servicesMaxChargeableDays['1048'];
    } else {
      price += vehicle.pricingData.nonMember.fiveHundredGramsCOTwo  / 100 * reservationLength;
      co2CompensationReservationLength = reservationLength;
    }
  }
  if (services.co2compensation == '1049') {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1049']) {
      price += vehicle.pricingData.nonMember.sevenHundredGramsCOTwo  / 100 * vehicle.servicesMaxChargeableDays['1049'];
      co2CompensationReservationLength = vehicle.servicesMaxChargeableDays['1049'];
    } else {
      price += vehicle.pricingData.nonMember.sevenHundredGramsCOTwo  / 100 * reservationLength;
      co2CompensationReservationLength = reservationLength;
    }
  }
  return (price); */

};

/* calculate discounted services together
/* km price in case of other than standard 100km/d case
/* insurances
/* export
/* hook
/* value is not multiplied by the length of the reservation
*/

export const servicesPriceDiscount = function (vehicle: IVehicleSearch, services: any, reservationLength?: number) {
    if(!services || !reservationLength) return 0;

    if (vehicle.privateData?.vip) { return 0 };

    let kmPricewithCoupon;
    if (services.kmRange === 0) {
      kmPricewithCoupon = vehicle.pricingData.withCoupon!.unlimitedKilometers / 100;
    } else {
      if (services.kmRange > 100) {
        // additional km over 100 are not part of the discount, so we will use base price
        kmPricewithCoupon = vehicle.pricingData.base.pricePerKilometer / 100 * (services.kmRange - 100);
      } else {
        kmPricewithCoupon = 0;
      }
    }

    if (kmPricewithCoupon < 0) {
      kmPricewithCoupon = 0;
    }

    let price = kmPricewithCoupon*reservationLength;
    if (services.insurance.includes('1030')) {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1030']) {
        price += vehicle.pricingData.withCoupon!.highDeductible / 100 * vehicle.servicesMaxChargeableDays['1030'];
      } else {
        price += vehicle.pricingData.withCoupon!.highDeductible / 100 * reservationLength;
      }
    }

    if (services.insurance.includes('1028'))  {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1028']) {
        price += vehicle.pricingData.withCoupon!.lowDeductible / 100 * vehicle.servicesMaxChargeableDays['1028'];
      } else {
        price += vehicle.pricingData.withCoupon!.lowDeductible / 100 * reservationLength;
      }
    }

    if (services.insurance.includes('1053'))  {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1053']) {
        price += vehicle.pricingData.withCoupon!.midDeductible / 100 * vehicle.servicesMaxChargeableDays['1053'];
      } else {
        price += vehicle.pricingData.withCoupon!.midDeductible / 100 * reservationLength;
      }
    }

    if (services.windshield === true) {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1026']) {
        price += vehicle.pricingData.withCoupon!.windshieldInsurance / 100 * vehicle.servicesMaxChargeableDays['1026'];
      } else {
        price += vehicle.pricingData.withCoupon!.windshieldInsurance / 100 * reservationLength;
      }
    }

    if (services.tireInsurance === true) {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1038']) {
        price += vehicle.pricingData.withCoupon!.tireInsurance / 100 * vehicle.servicesMaxChargeableDays['1038'];
      } else {
        price += vehicle.pricingData.withCoupon!.tireInsurance / 100 * reservationLength;
      }
    }

    if (services.cancellationInsurance === true) {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1040']) {
        price += vehicle.pricingData.withCoupon!.cancellationInsurance / 100 * vehicle.servicesMaxChargeableDays['1040'];
      } else {
        price += vehicle.pricingData.withCoupon!.cancellationInsurance / 100 * reservationLength;
      }
    }
    if (services.additionalDriver === true) {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1041']) {
        price += vehicle.pricingData.withCoupon!.additionalDriver / 100 * vehicle.servicesMaxChargeableDays['1041'];
      } else {
        price += vehicle.pricingData.withCoupon!.additionalDriver / 100 * reservationLength;
      }
    }

    if (services.export === true) {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1023']) {
        price += vehicle.pricingData.withCoupon!.export / 100 * vehicle.servicesMaxChargeableDays['1023'];
      } else {
        price += vehicle.pricingData.withCoupon!.export / 100 * reservationLength;
      }
    }
    if (services.hook === true) {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1027']) {
        price += vehicle.pricingData.withCoupon!.towHitch / 100 * vehicle.servicesMaxChargeableDays['1027'];
      } else {
        price += vehicle.pricingData.withCoupon!.towHitch / 100 * reservationLength;
      }
    }

    if (services.co2compensation === '1047') {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1047']) {
        price += vehicle.pricingData.withCoupon!.hundredTwentyFiveGramsCOTwo! / 100 * vehicle.servicesMaxChargeableDays['1047'];
        services.co2CompensationReservationLength = vehicle.servicesMaxChargeableDays['1047'];
      } else {
        price += vehicle.pricingData.withCoupon!.hundredTwentyFiveGramsCOTwo! / 100 * reservationLength;
        services.co2CompensationReservationLength = reservationLength;
      }
    }

    if (services.co2compensation === '1048') {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1048']) {
        price += vehicle.pricingData.withCoupon!.fiveHundredGramsCOTwo  / 100 * vehicle.servicesMaxChargeableDays['1048'];
        services.co2CompensationReservationLength = vehicle.servicesMaxChargeableDays['1048'];
      } else {
        price += vehicle.pricingData.withCoupon!.fiveHundredGramsCOTwo  / 100 * reservationLength;
        services.co2CompensationReservationLength = reservationLength;
      }
    }

    if (services.co2compensation === '1049') {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1049']) {
        price += vehicle.pricingData.withCoupon!.sevenHundredGramsCOTwo  / 100 * vehicle.servicesMaxChargeableDays['1049'];
        services.co2CompensationReservationLength = vehicle.servicesMaxChargeableDays['1049'];
      } else {
        price += vehicle.pricingData.withCoupon!.sevenHundredGramsCOTwo  / 100 * reservationLength;
        services.co2CompensationReservationLength = reservationLength;
      }
    }

    return (price); 
};

/* calculate base price together
/* params @vehicle
*/

export const basePrice = function (vehicle: IVehicleSearch, services: any = undefined, reservationLength:number|undefined = undefined): number {
  return vehicle.pricingData.base.totalPrice / 100 + servicesPriceBase(vehicle, services, reservationLength);
};

/* calculate base price together for onSalesVehicle
/* params @vehicle
/*
*/
export const baseOnSalesDiscountPrice = function(vehicle: IVehicleSearch, services: any = undefined, reservationLength: number | undefined = undefined): number {
    if(!vehicle.onsale) throw Error("baseOnSalesDiscountPrice: vehicle.onsale = false"); //this shoulndt happen
    return ((vehicle.onsale.price*vehicle.onsale.discountmultiplier) / 100) + servicesPriceBase(vehicle, services, reservationLength);
  };

/* calculate base price together for onSalesVehicle before discount
/* params @vehicle
/*
*/
export const baseOnSalesPrice = function(vehicle: IVehicleSearch, services: any = undefined, reservationLength: number | undefined = undefined): number {
  if(!vehicle.onsale) throw Error("baseOnSalesPrice: vehicle.onsale = false"); //this shoulndt happen
  return (vehicle.onsale.price / 100) + servicesPriceBase(vehicle, services, reservationLength);
};

/* calculate discounted price together
/* params @vehicle
/*
*/

export const discountPrice = function (vehicle: IVehicleSearch, services: any, reservationLength: number) {
  if (!vehicle.pricingData.withCoupon) {
    throw Error("Coupon is false or invalid")
  }

  return vehicle.pricingData.withCoupon.totalPrice / 100 + servicesPriceDiscount(vehicle,services,reservationLength);
};

/* calculate discount value
/* params @vehicle
/*
*/

export const discountValue = function (vehicle: IVehicleSearch,services: any=undefined,reservationLength:number|undefined=undefined):number {
  if (vehicle.privateData?.vip) {
    return 0; // cannot get discount on VIP vehicle
  }

  let totalDiscountPrice;
  if (vehicle.pricingData.nonMember) {
    if (!vehicle.pricingData.withCoupon) {
      totalDiscountPrice = vehicle.pricingData.nonMember.totalPrice / 100 + nonMemberServicesPriceBase(vehicle);
      return (vehicle.pricingData.base.totalPrice / 100 + servicesPriceBase(vehicle,services,reservationLength)) - totalDiscountPrice;
    } else {
      totalDiscountPrice = vehicle.pricingData.withCoupon.totalPrice / 100 + servicesPriceDiscount(vehicle,services,reservationLength);
      return (vehicle.pricingData.base.totalPrice / 100 + servicesPriceBase(vehicle,services,reservationLength)) - totalDiscountPrice;
    }
  } else {
    if (!vehicle.pricingData.withCoupon) {
      return 0;
    }
    totalDiscountPrice = vehicle.pricingData.withCoupon.totalPrice / 100 + servicesPriceDiscount(vehicle,services,reservationLength);
    return (vehicle.pricingData.base.totalPrice / 100 + servicesPriceBase(vehicle,services,reservationLength)) - totalDiscountPrice;
  }
};
